import axios from "axios";

const localUrl = process.env.REACT_APP_LOCAL_URL;
//const localUrl = 'https://urchin-app-n63ko.ondigitalocean.app';
const productionUrl = "/";
// const productionUrl = "https://urchin-app-n63ko.ondigitalocean.app";

//******************************/
//Api Config
//******************************/
export const setToken = (token) => {
  API.interceptors.request.use(async (req) => {
    //   if (localStorage.getItem('profile')) {
    //     req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    //   }
    //const token = setToken

    const config = {
      "Content-type": "application/json",
      "vvx-auth-token": token,
    };

    req.headers = config;

    return req;
  });
};

const API = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? productionUrl : localUrl,
});

export const authUser = (data) => API.post(`/api/auth/`, data)

export const getAllData = async ({ limit = 0, page = 0, date, dates }) => {
  const response = await API.get(`/api/data?page=${page}&limit=${limit}&date=${date}&dates=${dates}`);

  return response.data;
};

export const addDataRequest = async (data) => {
  const response = await API.post(`/api/data`, data);
  return response.data;
};

export const updateDataRequest = async ({ id, data }) => {
  const response = await API.post(
    `/api/data?id=${id.toString()}`,
    data
  );
  return response.data;
};

export const deleteDataRequest = async (id) => {
  const response = await API.delete(`/api/data?id=${id.toString()}`);
  return response.data;
};

//******************************/
//Activity Logs Api Requests//
//******************************/

export const getActivityLogs = async ({ page = 1, limit = 20, userEmail, action, tableName, startDate, endDate }) => {
  let url = `/api/activity-logs?page=${page}&limit=${limit}`;
  if (userEmail) url += `&userEmail=${userEmail}`;
  if (action) url += `&action=${action}`;
  if (tableName) url += `&tableName=${tableName}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  
  const response = await API.get(url);
  
  // Return the new backend response format directly
  return response.data;
};

export const getActivityLogsSummary = async ({ startDate, endDate }) => {
  let url = `/api/activity-logs/summary`;
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  const response = await API.get(url);
  
  // Return the raw backend response
  return response.data;
};

//******************************/
//Auth Api Requests//
//******************************/

//Auth Api Requests
// export const registerUser = () => API.post(`/api/auth`)
// export const authUser = (data) => API.post(`/api/auth/login`, data);

//User Management Api Requests
export const getAllUsers = async () => {
  const response = await API.get(`/api/auth/users`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await API.post(`/api/auth/register`, userData);
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await API.delete(`/api/auth/users/${userId}`);
  return response.data;
};

//******************************/
//Config Parameters Api Requests//
//******************************/

export const getConfig = async () => {
  const response = await API.get(`/api/config`);
  return response.data;
};

export const updateConfig = async (configData) => {
  const response = await API.put(`/api/config`, configData);
  return response.data;
};
